import React, { useState, useContext, useEffect } from 'react';
// import { useTranslation }            from 'react-i18next';
import { historyPropType } from '~/config/routerPropTypes';
import { showMedicalAppointments } from '~/config/routes';
import Request from '~/providers/Request';
import MedicalAppointments from './context';
import MedicalAppointmentsRecord from '~/records/MedicalAppointmentsRecord';
import Form from './FormEdit';
import CurrentUser from '../../contexts/CurrentUser';

// import { toast } from 'react-toastify';

function EditRecord({ history }) {
  const [record, setRecord] = useState(new MedicalAppointmentsRecord());
  const [loading, setLoading] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [loadedStatus, setLoadedStatus] = useState('');
  const { records, addRecords } = useContext(MedicalAppointments);
  const { id } = history.location.route.getParams();
  const { user } = useContext(CurrentUser);

  // const { t } = useTranslation();

  useEffect(() => {
    async function fetchData(id) {
      if (records && records[id]) {
        record.updateAttributes(records[id]);
      }

      setLoading(true);
      Request.get(`/admin/medical_appointment/${id}`, {})
        .then((response) => {
          setLoading(false);
          addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
          Request.get(`/admin/users/${response.data.user_id}`).then((value) => {
            setUserRole(value.data);
          });
          setRecord(record.updateAttributes(response.data));
          setLoadedStatus(response.data.status);
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, []);

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  async function onSubmit(callback) {
    const data = record.toParams();

    // if (!data.data.attributes.doctor_id) {
    //   toast.error(t('medicalAppointments.extras.doctor_required'));
    //   return false;
    // }

    setLoading(true);
    Request.put(
      `/admin/medical_appointment/${id}`,
      data,
      {},
      { controller: 'medicalAppointments' }
    )
      .then((resp) => {
        callback();
        setLoading(false);
        history.push(showMedicalAppointments.reverse(resp.data));
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  return (
    <>
      <Form
        onSubmit={onSubmit}
        record={record}
        user={userRole}
        handleChange={handleChange}
        loading={loading}
        setRecord={setRecord}
        userProfile={user}
        loadedStatus={loadedStatus}
      />
    </>
  );
}

EditRecord.propTypes = {
  history: historyPropType,
};

export default EditRecord;
